import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryParamsLike, SortDescriptor } from '@technocom/common/data';
import { HttpParamsEncoder, HttpParamsLike, HttpUtils } from '@technocom/common/http';
import { MultiValueMap } from '@technocom/common/platform';
import { EntityRepositoryServiceBase, EntityRequestOverrides } from '@technocom/data';
import { Entity, EntityKeyOf, EntityType, EntityValueMapOf } from '@technocom/data/core';

/**
 * Расширение стандартного репозитория сущностей для преобразования формата параметров запроса данных
 * под требования сервера.
 **/
@Injectable()
export class EntityRepositoryExtensionService<T extends Entity = any> extends EntityRepositoryServiceBase<
  EntityKeyOf<T>,
  T,
  EntityType<EntityValueMapOf<T>, T>
> {
  protected composeParams(data: HttpParamsLike | QueryParamsLike, overrides?: EntityRequestOverrides): HttpParams {
    // преобразовываем дефолтные параметры для сервиса.
    if ((data as any).page || (data as any).pageSize) {
      data = data as QueryParamsLike;
      const json = HttpUtils.stringifyIn(data.toJSON()) as MultiValueMap<string | number>;

      if (data.hasPage()) {
        // на сервисе начинается с 0, по дефолту с 1
        json.page = data.page - 1;
      }

      if (data.hasPageSize()) {
        // заменяем свойство pageSize на size
        json.size = data.pageSize;

        delete json.pageSize;
      }

      if (data.hasSort()) {
        // преобразовываем sort
        json.sort = data.getSort().map(sortConverter);
      }

      return super.composeParams(new HttpParams({ fromObject: json, encoder: HttpParamsEncoder.INSTANCE }), overrides);
    }

    return super.composeParams(data, overrides);
  }
}

function sortConverter(rule: SortDescriptor): string {
  return rule.field + ',' + rule.dir;
}
